
export function AutoBind(target) {
	const wontBind = [
		'constructor', // for state init and this bind
		'render',
		'componentDidMount', // ok
		'shouldComponentUpdate', // ok
		'getSnapshotBeforeUpdate', // ok
		'componentDidUpdate', // ok
		'componentWillUnmount', // ok
		'componentDidCatch', // ok

		'componentWillMount', // legacy, do not use
		'componentWillReceiveProps', // legacy, do not use
		'componentWillUpdate', // legacy, do not use
	];
	const objPrototype = Object.getPrototypeOf(target);
	const propNames = Object.getOwnPropertyNames(objPrototype);
	for (let i = 0; i < propNames.length; ++i) {
		const key = propNames[i];
		const fn = objPrototype[key];
		if ((typeof (fn) === 'function') && (wontBind.indexOf(key) === -1)) {
			//console.log(key);
			target[key] = fn.bind(target);
		}
	}
}
